module.exports = __webpack_public_path__ + "img/principles-us.6beb26be.svg";